"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PresenterSettings = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _JoinComponent = require("../Join/JoinComponent.styled");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _CameraPreview = require("../CameraPreview/CameraPreview");
var _FormTextbox = require("../FormTextbox/FormTextbox");
var _Button = require("../Button/Button");
var _PresenterSettings = require("./PresenterSettings.styled");
var _PresenterSettingsMedia = _interopRequireDefault(require("./PresenterSettingsMedia"));
var _Sources = require("@studio/constants/Sources");
var _PresenterSettingsMedia2 = require("./PresenterSettingsMedia.styled");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * @description This will be named to PresenterSettings when the newJoinFlow flag is deprecated
 */
var PresenterSettings = exports.PresenterSettings = function PresenterSettings(_ref) {
  var _names$, _names$slice$join, _source$description, _source$title, _labelMap$source$type, _titleMap$source$type, _thumbnailMap$source$;
  var source = _ref.source,
    meetingSession = _ref.meetingSession,
    attendeeTiles = _ref.attendeeTiles,
    onSubmit = _ref.onSubmit,
    onCancel = _ref.onCancel,
    AttendeeTileComponent = _ref.AttendeeTileComponent;
  var names = source.title.split(' ');
  var _firstName = (_names$ = names[0]) !== null && _names$ !== void 0 ? _names$ : '';
  var _lastName = (_names$slice$join = names.slice(1).join(' ')) !== null && _names$slice$join !== void 0 ? _names$slice$join : '';
  var _description = (_source$description = source.description) !== null && _source$description !== void 0 ? _source$description : '';
  var _useState = (0, _react.useState)(_firstName),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    firstName = _useState2[0],
    setFirstName = _useState2[1];
  var _useState3 = (0, _react.useState)(_lastName),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    lastName = _useState4[0],
    setLastName = _useState4[1];
  var _useState5 = (0, _react.useState)(_description),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    description = _useState6[0],
    setDescription = _useState6[1];
  var _useState7 = (0, _react.useState)((_source$title = source.title) !== null && _source$title !== void 0 ? _source$title : ''),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    title = _useState8[0],
    setTitle = _useState8[1];
  var hasFirstNameExceededLimit = firstName.trim().length > 30;
  var hasLastNameExceededLimit = lastName.trim().length > 50;
  var hasDescriptionExceededLimit = description.trim().length > 80;
  var presenterTitle = "".concat(firstName, " ").concat(lastName);
  var hasPresenterTitle = presenterTitle.trim().length > 0;
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    var source_title = source.type === _Sources.CAMERA_PRESENTER ? "".concat(firstName, " ").concat(lastName) : title;
    var payload = {
      source_title: source_title,
      description: description
    };
    onSubmit(payload);
  };
  var videoNode = /*#__PURE__*/_react["default"].createElement(_PresenterSettings.CameraView, null, /*#__PURE__*/_react["default"].createElement(AttendeeTileComponent, {
    attendeeId: source.value,
    attendeeTiles: attendeeTiles,
    meetingSession: meetingSession,
    isCameraOn: true,
    isLocalAttendee: false
  }));
  var hasValidationError = !hasPresenterTitle || hasFirstNameExceededLimit || hasLastNameExceededLimit || hasDescriptionExceededLimit;
  var titleMap = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _Sources.VIDEO_FILE, 'Edit video file settings'), _Sources.SCREEN_PRESENTER, 'Edit screen share settings'), _Sources.PDF_FILE, 'Rename file'), _Sources.CAMERA_PRESENTER, 'Settings'), _Sources.AUDIO_FILE, 'Edit audio settings'), _Sources.IMAGE_FILE, 'Edit image settings');
  var labelMap = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _Sources.VIDEO_FILE, 'Video name'), _Sources.SCREEN_PRESENTER, 'Screen share name'), _Sources.PDF_FILE, ''), _Sources.CAMERA_PRESENTER, 'Name'), _Sources.AUDIO_FILE, 'Audio name'), _Sources.IMAGE_FILE, 'Image name');
  var SettingsFormContent = /*#__PURE__*/_react["default"].createElement(_reactstrap.Row, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Col, {
    md: 12
  }, /*#__PURE__*/_react["default"].createElement(_FormTextbox.FormTextbox, {
    labelText: (_labelMap$source$type = labelMap[source.type]) !== null && _labelMap$source$type !== void 0 ? _labelMap$source$type : 'Media name',
    id: "title",
    "data-testid": "source-title",
    value: title,
    required: true,
    onChange: function onChange(event) {
      return setTitle(event.target.value);
    }
  })));
  var CameraPresenterFormContent = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Row, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Col, {
    md: 6
  }, /*#__PURE__*/_react["default"].createElement(_FormTextbox.FormTextbox, {
    "data-testid": "firstName",
    id: "firstName",
    labelText: "First name",
    value: firstName,
    required: true,
    onChange: function onChange(event) {
      return setFirstName(event.target.value);
    },
    hasError: hasFirstNameExceededLimit,
    errorMessage: hasFirstNameExceededLimit && "First Name can't exceed 30 characters"
  })), /*#__PURE__*/_react["default"].createElement(_reactstrap.Col, {
    md: 6
  }, /*#__PURE__*/_react["default"].createElement(_FormTextbox.FormTextbox, {
    "data-testid": "lastName",
    id: "lastName",
    labelText: "Last name",
    value: lastName,
    required: true,
    onChange: function onChange(event) {
      return setLastName(event.target.value);
    },
    hasError: hasLastNameExceededLimit,
    errorMessage: hasLastNameExceededLimit && "Last Name can't exceed 50 characters"
  }))), /*#__PURE__*/_react["default"].createElement(_FormTextbox.FormTextbox, {
    "data-testid": "title",
    id: "title",
    labelText: "Title",
    value: description,
    onChange: function onChange(event) {
      return setDescription(event.target.value);
    },
    hasError: hasDescriptionExceededLimit,
    errorMessage: hasDescriptionExceededLimit && "Title can't exceed 80 characters"
  }));
  var PresenterSourceThumbnail = /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCameraPreviewWrapper, null, /*#__PURE__*/_react["default"].createElement(_CameraPreview.CameraPreview, {
    presenterTitle: presenterTitle,
    presenterDescription: description,
    videoNode: videoNode,
    meetingSession: meetingSession,
    browserBlock: false
  }));
  var thumbnailMap = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _Sources.PDF_FILE, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null)), _Sources.CAMERA_PRESENTER, PresenterSourceThumbnail), _Sources.SCREEN_PRESENTER, /*#__PURE__*/_react["default"].createElement(_PresenterSettings.CameraView, null, videoNode));
  return /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledPresenterSettingsCardBody, null, /*#__PURE__*/_react["default"].createElement(_PresenterSettingsMedia2.StyledPresenterSettingsCardContent, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.CardTitle, {
    tag: "h4"
  }, (_titleMap$source$type = titleMap[source.type]) !== null && _titleMap$source$type !== void 0 ? _titleMap$source$type : 'Edit media settings'), /*#__PURE__*/_react["default"].createElement(_PresenterSettings.ThumbnailWrapper, null, (_thumbnailMap$source$ = thumbnailMap[source.type]) !== null && _thumbnailMap$source$ !== void 0 ? _thumbnailMap$source$ : /*#__PURE__*/_react["default"].createElement(_PresenterSettingsMedia["default"], {
    source: source
  })), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, source.type === _Sources.CAMERA_PRESENTER ? CameraPresenterFormContent : SettingsFormContent)), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardFooter, null, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    onClick: onCancel,
    color: "outline",
    className: "me-2",
    "data-testid": "cancel"
  }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    disabled: hasValidationError,
    onClick: handleSubmit,
    color: "primary",
    "data-testid": "submit"
  }, "Done")));
};
PresenterSettings.propTypes = {
  source: _propTypes["default"].object.isRequired,
  meetingSession: _propTypes["default"].object.isRequired,
  attendeeTiles: _propTypes["default"].object.isRequired,
  onSubmit: _propTypes["default"].func.isRequired,
  onCancel: _propTypes["default"].func.isRequired,
  AttendeeTileComponent: _propTypes["default"].elementType
};